import { render, staticRenderFns } from "./JBProposalReferences.vue?vue&type=template&id=49cd2bba"
import script from "./JBProposalReferences.vue?vue&type=script&lang=js"
export * from "./JBProposalReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports